<template>
<v-container style="height: 80vh;" class="d-flex align-center">
  <v-card style="text-align: center; max-width: 500px;" class="mx-auto">
    <v-card-title class="justify-center">
      Vahvista sähköposti
    </v-card-title>
    <v-card-subtitle>
      Lähetimme sähköpostiisi vahvistuskoodin. Tarkista myös roskaposti.
    </v-card-subtitle>
    <v-card-text class="mt-6">
      <v-otp-input
        class="mx-6"
        v-model="confirmation_string"
        @finish="submit"
        length="6"
      ></v-otp-input>
    </v-card-text>
  </v-card>
</v-container>
</template>

<script>
import { mapActions } from 'vuex/dist/vuex.common.js';

export default {
  data: () => ({
    confirmation_string: ''
  }),
  methods: {
    ...mapActions('user', [
      'confirmEmail'
    ]),
    ...mapActions('noti', [
      'error',
      'success'
    ]),
    resendEmail() {

    },
    submit() {
      this.confirmEmail(this.confirmation_string)
        .then(() => {
          this.$router.push('/')
          this.success('Sähköposti vahvistettu!')
        })
        .catch((e) => {
          console.log(e)
          this.error(e)
        })
    }
  }
}
</script>